// src/components/Navbar.js - Enhanced Version
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelope,
  faHeadset,
  faCalendarCheck,
  faBars,
  faTimes, // Added for close icon
  faMapMarkerAlt,
  faShieldAlt,
  faAngleDown,
  faHardHat
} from '@fortawesome/free-solid-svg-icons';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navbarRef = useRef(null); // Ref for the navbar

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [navbarRef]);


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };


  const closeAllMenus = () => {
    setMenuOpen(false);
  };

  // Close menus when route changes
  useEffect(() => {
    closeAllMenus();
  }, [location.pathname]);


  const isActive = (path) => {
    if (path === '/services' && location.pathname.startsWith('/services')) return true;
    return location.pathname === path;
  };


  return (
    <>
      {/* TOP BANNER */}
      <div className="top-banner">
        <div className="top-banner__container">
          <div className="banner__left">
            <span className="banner__label">
              <FontAwesomeIcon icon={faHeadset} className="banner__icon" />
              Call Our Experts:
            </span>
            <a href="tel:07735005695" className="banner__phone">
              <FontAwesomeIcon icon={faPhone} className="banner__icon-phone" />
              07735 005 695
            </a>
            <a href="tel:07393861306" className="banner__phone">
              <FontAwesomeIcon icon={faPhone} className="banner__icon-phone" />
              07393 861 306
            </a>
          </div>
          <div className="banner__right">
            <span className="banner__location">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="banner__icon" />
              Glossop & Surrounding Areas
            </span>
            <Link to="/contact" className="banner__contact-link" onClick={closeAllMenus}>
              <FontAwesomeIcon icon={faEnvelope} className="banner__icon" />
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      {/* MAIN NAVBAR */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-active' : ''}`} ref={navbarRef}>
        <div className="navbar__container">
          <div className="navbar__left">
            <Link to="/" className="navbar__home-link" onClick={closeAllMenus}>
              <img
                src="/gallery/logo.PNG" // Ensure this path is correct in your public folder
                alt="Old Glossop Roofing Logo"
                className="navbar__img-logo"
              />
              <div className="navbar__brand-text-container">
                <span className="navbar__brand-text">Old Glossop Roofing</span>
                <span className="navbar__brand-tagline">Quality You Can Trust, Service You Expect</span>
              </div>
            </Link>
          </div>

          <ul className={`navbar__menu ${menuOpen ? 'active' : ''}`}>
            <li className="navbar__item">
              <Link
                to="/"
                className={`navbar__link ${isActive('/') ? 'active' : ''}`}
                onClick={closeAllMenus}
              >
                Home
              </Link>
            </li>
            <li className="navbar__item">
              <Link
                to="/services"
                className={`navbar__link ${isActive('/services') ? 'active' : ''}`}
                onClick={closeAllMenus}
              >
                Services
              </Link>
            </li>
              <li className="navbar__item">
                <Link
                  to="/gallery"
                  className={`navbar__link ${isActive('/gallery') ? 'active' : ''}`}
                  onClick={closeAllMenus}
                >
                  Gallery
                </Link>
            </li>
            <li className="navbar__item">
              <Link
                to="/areas-covered"
                className={`navbar__link ${isActive('/areas-covered') ? 'active' : ''}`}
                onClick={closeAllMenus}
              >
                Areas Covered
              </Link>
            </li>
            <li className="navbar__item">
              <Link
                to="/contact"
                className={`navbar__link ${isActive('/contact') ? 'active' : ''}`}
                onClick={closeAllMenus}
              >
                Contact
              </Link>
            </li>
            {/* Mobile-only CTAs */}
            <li className="navbar__item mobile-only-cta">
              <a href="tel:07735005695" className="navbar__call-mobile" onClick={closeAllMenus}>
                <FontAwesomeIcon icon={faPhone} /> Call Now
              </a>
            </li>
            <li className="navbar__item mobile-only-cta">
              <Link to="/contact" className="navbar__quote-mobile" onClick={closeAllMenus}>
                <FontAwesomeIcon icon={faCalendarCheck} /> Get a Free Quote
              </Link>
            </li>
          </ul>

          <div className="navbar__right">
            <div className="navbar__trust-wrapper">
              <div className="navbar__expert-roofers">
                <FontAwesomeIcon icon={faHardHat} className="subtitle-icon" />
                <span>Expert Local Roofers</span>
              </div>
              <div className="navbar__trust-badges">
                <div className="nav-badge">
                  <FontAwesomeIcon icon={faShieldAlt} />
                  <span>Fully Insured</span>
                </div>
                <div className="nav-badge nav-badge--experience">
                  <span>15+</span>
                  <span>Years Exp.</span>
                </div>
              </div>
            </div>
            <Link to="/contact" className="navbar__cta-button" onClick={closeAllMenus}>
              Free Quote <FontAwesomeIcon icon={faCalendarCheck} className="cta-icon" />
            </Link>
          </div>

          <button
            className="hamburger__toggle"
            onClick={toggleMenu}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>
        </div>
      </nav>
    </>
  );
}

export default Navbar;